module.exports = __webpack_public_path__ + "media/pages/press/downloads/thumbnails/LifeTime_Software_tn-54b49da8e865f393db379150adef1e86.jpg";